"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title4Styles = exports.title4 = exports.title3Styles = exports.title3 = exports.title2Styles = exports.title2 = exports.title1Styles = exports.title1 = exports.legalStyles = exports.legal = exports.label2Styles = exports.label2 = exports.label1Styles = exports.label1 = exports.headlineStyles = exports.headline = exports.display3Styles = exports.display3 = exports.display2Styles = exports.display2 = exports.display1Styles = exports.display1 = exports.captionStyles = exports.caption = exports.bodyStyles = exports.body = void 0;
require("./textStyles.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const display1Styles = {
  fontSize: 'var(--display1-font-size)',
  lineHeight: 'var(--display1-line-height)',
  fontWeight: 'var(--display1-font-weight)',
  fontFamily: 'var(--display1-font-family)'
};
exports.display1Styles = display1Styles;
const display2Styles = {
  fontSize: 'var(--display2-font-size)',
  lineHeight: 'var(--display2-line-height)',
  fontWeight: 'var(--display2-font-weight)',
  fontFamily: 'var(--display2-font-family)'
};
exports.display2Styles = display2Styles;
const display3Styles = {
  fontSize: 'var(--display3-font-size)',
  lineHeight: 'var(--display3-line-height)',
  fontWeight: 'var(--display3-font-weight)',
  fontFamily: 'var(--display3-font-family)'
};
exports.display3Styles = display3Styles;
const title1Styles = {
  fontSize: 'var(--title1-font-size)',
  lineHeight: 'var(--title1-line-height)',
  fontWeight: 'var(--title1-font-weight)',
  fontFamily: 'var(--title1-font-family)'
};
exports.title1Styles = title1Styles;
const title2Styles = {
  fontSize: 'var(--title2-font-size)',
  lineHeight: 'var(--title2-line-height)',
  fontWeight: 'var(--title2-font-weight)',
  fontFamily: 'var(--title2-font-family)'
};
exports.title2Styles = title2Styles;
const title3Styles = {
  fontSize: 'var(--title3-font-size)',
  lineHeight: 'var(--title3-line-height)',
  fontWeight: 'var(--title3-font-weight)',
  fontFamily: 'var(--title3-font-family)'
};
exports.title3Styles = title3Styles;
const title4Styles = {
  fontSize: 'var(--title4-font-size)',
  lineHeight: 'var(--title4-line-height)',
  fontWeight: 'var(--title4-font-weight)',
  fontFamily: 'var(--title4-font-family)'
};
exports.title4Styles = title4Styles;
const headlineStyles = {
  fontSize: 'var(--headline-font-size)',
  lineHeight: 'var(--headline-line-height)',
  fontWeight: 'var(--headline-font-weight)',
  fontFamily: 'var(--headline-font-family)'
};
exports.headlineStyles = headlineStyles;
const bodyStyles = {
  fontSize: 'var(--body-font-size)',
  lineHeight: 'var(--body-line-height)',
  fontWeight: 'var(--body-font-weight)',
  fontFamily: 'var(--body-font-family)'
};
exports.bodyStyles = bodyStyles;
const label1Styles = {
  fontSize: 'var(--label1-font-size)',
  lineHeight: 'var(--label1-line-height)',
  fontWeight: 'var(--label1-font-weight)',
  fontFamily: 'var(--label1-font-family)'
};
exports.label1Styles = label1Styles;
const label2Styles = {
  fontSize: 'var(--label2-font-size)',
  lineHeight: 'var(--label2-line-height)',
  fontWeight: 'var(--label2-font-weight)',
  fontFamily: 'var(--label2-font-family)'
};
exports.label2Styles = label2Styles;
const captionStyles = {
  fontSize: 'var(--caption-font-size)',
  lineHeight: 'var(--caption-line-height)',
  fontWeight: 'var(--caption-font-weight)',
  fontFamily: 'var(--caption-font-family)'
};
exports.captionStyles = captionStyles;
const legalStyles = {
  fontSize: 'var(--legal-font-size)',
  lineHeight: 'var(--legal-line-height)',
  fontWeight: 'var(--legal-font-weight)',
  fontFamily: 'var(--legal-font-family)'
};
exports.legalStyles = legalStyles;
const display1 = "cds-display1-du4t46c";
exports.display1 = display1;
const display2 = "cds-display2-d1ntbeaw";
exports.display2 = display2;
const display3 = "cds-display3-dynlspi";
exports.display3 = display3;
const title1 = "cds-title1-toujgnf";
exports.title1 = title1;
const title2 = "cds-title2-t16z3je5";
exports.title2 = title2;
const title3 = "cds-title3-t37r1y";
exports.title3 = title3;
const title4 = "cds-title4-tkt8qnl";
exports.title4 = title4;
const headline = "cds-headline-htr1998";
exports.headline = headline;
const body = "cds-body-bb7l4gg";
exports.body = body;
const label1 = "cds-label1-lvviwwo";
exports.label1 = label1;
const label2 = "cds-label2-ln29cth";
exports.label2 = label2;
const caption = "cds-caption-c5adacs";
exports.caption = caption;
const legal = "cds-legal-l7opkku";
exports.legal = legal;